import { X } from "lucide-react";
import { useState } from "react";

interface JMESPathAssistantPopupProps {
    onClose: () => void;
    onSubmit: (prompt: string) => void;
    isGenerating: boolean;
}

export function JMESPathAssistantPopup({ onClose, onSubmit, isGenerating }: JMESPathAssistantPopupProps) {
    const [prompt, setPrompt] = useState('');
    const [example, setExample] = useState('');
    const [desired, setDesired] = useState('');

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[51]">
            <div className="bg-white p-6 rounded-lg shadow-lg relative max-w-2xl w-full">
                <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" onClick={onClose}>
                    <X className="w-5 h-5" />
                </button>

                <h3 className="text-lg font-medium mb-4 text-gray-900">JMESPath Assistant</h3>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Describe the transformation you want:
                        </label>
                        <textarea
                            className="w-full p-2 border rounded-md focus:ring-2 focus:ring-orange-600"
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            rows={3}
                            placeholder="e.g., Extract all names from users array and create a list of them"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Example input JSON (optional):
                        </label>
                        <textarea
                            className="w-full p-2 border rounded-md focus:ring-2 focus:ring-orange-600"
                            value={example}
                            onChange={(e) => setExample(e.target.value)}
                            rows={5}
                            placeholder='e.g., {"users": [{"name": "John", "age": 30}, {"name": "Alice", "age": 25}]}'
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Desired output (optional):
                        </label>
                        <textarea
                            className="w-full p-2 border rounded-md focus:ring-2 focus:ring-orange-600"
                            value={desired}
                            onChange={(e) => setDesired(e.target.value)}
                            rows={3}
                            placeholder='e.g., ["John", "Alice"]'
                        />
                        <p className="text-xs text-left text-gray-900">AI Can produce incorrect results. <a className="text-blue-500 cursor-pointer" href="https://jmespath.org/tutorial.html" rel="noreferrer" target="_blank">Test/Learn Here</a>.</p>
                    </div>

                    <div className="flex justify-end space-x-3 pt-4">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                const fullPrompt = `
Description: ${prompt}
${`Example input: ${example}`}
${`Desired output: ${desired}`}
`;
                                onSubmit(fullPrompt);
                            }}
                            disabled={isGenerating || !prompt.trim()}
                            className={`px-4 py-2 rounded text-white ${isGenerating || !prompt.trim() ? 'bg-gray-400' : 'bg-orange-600 hover:bg-orange-700'}`}
                        >
                            {isGenerating ? 'Generating...' : 'Generate JMESPath'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}